import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { ButtonComponentController } from "./ButtonComponentController";

import "./Button.html";
import "./Button.scss";

export class ButtonComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            buttonClass: "<?",
            buttonId: "<?",
            buttonType: "<?", // Only when not specifying url
            caption: "<",
            click: "&?",
            extraClasses: "<?",
            hasError: "<?",
            icon: "<?",
            isDisabled: "<?",
            isHidden: "<?",
            isLoading: "<",
            isTooltipHidden: "<?",
            response: "<?", // PREFERRED! IResponseWithLoading<T> or IResponse<T>-like
            secondaryIcon: "<?",
            tooltip: "<?",
            url: "<?",
        };
        this.controller = ButtonComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Button/Common/Button.html";

        this.transclude = false;
    }
}
